import { useState } from 'react';
import { Button } from 'src/@/components/ui/button';
import {
    Popover,
    PopoverContent,
    PopoverTrigger,
} from 'src/@/components/ui/popover';
import Iconify from 'src/components/Iconify';
import { ButtonLoading } from 'src/@/components/use/ButtonLoading';
import { useSnackbar } from 'notistack';
import v2_actionDeletarLead from 'src/actions/v2/crm/v2_actionDeletarLead';

// ----------------------------------------------------------------------

export default function DrawerDeleteLead({ lead, onCallback, open, onOpenChange }) {
    const [loading, setLoading] = useState(false);
    const { enqueueSnackbar } = useSnackbar();

    async function deletarLead() {
        try {
            setLoading(true);
            await v2_actionDeletarLead(lead?._id);
            setLoading(false);
            onCallback();
            enqueueSnackbar('Lead excluido com sucesso', { variant: 'success', autoHideDuration: 3000, anchorOrigin: { vertical: 'bottom', horizontal: 'left' } });
        } catch (error) {
            setLoading(false);
            console.log('error', error);
            enqueueSnackbar('Erro ao excluir lead. Tente novamente', { variant: 'error', autoHideDuration: 3000, anchorOrigin: { vertical: 'bottom', horizontal: 'left' } });
        }
    }

    return (
        <Popover open={open} onOpenChange={onOpenChange}>
            <PopoverTrigger asChild>
                <Button
                    className="h-8 w-8"
                    size="icon"
                    variant="outline"
                    title="Excluir negócio"
                    aria-label="Excluir negócio"
                >
                    <Iconify icon="eva:trash-2-outline" width={16} className="text-red-500" />
                </Button>
            </PopoverTrigger>
            <PopoverContent className="w-80 z-[9999] rounded-xl dark:bg-[#222529] dark:border-[#383838]">
                <div className="flex items-center gap-2.5 mb-3">
                    <div className="w-8 h-8 rounded-lg bg-red-50 dark:bg-red-500/10 flex items-center justify-center shrink-0">
                        <Iconify icon="eva:trash-2-outline" width={16} className="text-red-600 dark:text-red-400" />
                    </div>
                    <p className="text-sm font-semibold text-gray-900 dark:text-gray-100">Excluir negócio</p>
                </div>
                <div className="flex flex-col gap-4">
                    <p className="text-[13px] text-gray-600 dark:text-[#ABABAD]">
                        Deseja realmente excluir esse negócio? Essa ação não pode ser desfeita.
                    </p>
                    <div className="flex gap-2">
                        <Button variant="outline" className="flex-1" onClick={() => onOpenChange()}>Cancelar</Button>
                        <ButtonLoading
                            loading={loading}
                            onClick={() => deletarLead()}
                            className="flex-1 bg-red-500 hover:bg-red-600"
                        >
                            {loading ? 'Excluindo...' : 'Excluir'}
                        </ButtonLoading>
                    </div>
                </div>
            </PopoverContent>
        </Popover>
    );
}
